import axios from "axios";
const token = localStorage.getItem("token");
const baseurl = process.env.REACT_APP_API_URL;

export const uploadContractorData = async (data) => {
  try {
    const res = await axios({
      method: "post",
      url: baseurl + `/contractorForm`,
      data: data,
      headers: {
        token: token,
      },
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const uploadIndividualData = async (data) => {
  try {
    const res = await axios({
      method: "post",
      url: baseurl + `/individualForm`,
      data: data,
      headers: {
        token: token,
      },
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const uploadFarmerData = async (data) => {
  try {
    const res = await axios({
      method: "post",
      url: baseurl + `/farmerForm`,
      data: data,
      headers: {
        token: token,
      },
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
